/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BlockTime/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ClockFilled from 'DesignSystem/Svgs/Tysiav2ClockFilled/index'



/** @type {import('Simple/types.js').View} */
export default function BlockTime({
  children,
  viewPath = "/DesignSystem/TimegridScheduleNote/Header/BlockTime"
  
}) {
  return (<React.Fragment
>
<Tysiav2ClockFilled
  viewPath={`${viewPath}/Tysiav2ClockFilled`}
 fill2="#8562C7"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Block time"
 size="normal"
 weight="semibold"
/>
{children}
</React.Fragment>)
}